/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from "@angular/core";
import { AsyncSubject, Observable, BehaviorSubject } from "rxjs";
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  private profile: AsyncSubject<any> = new AsyncSubject();
  public profile$: Observable<any> = this.profile.asObservable();

  private userPicutre: BehaviorSubject<any> = new BehaviorSubject<string>("");
  public userPicutre$: Observable<any> = this.userPicutre.asObservable();

  private isExternal: BehaviorSubject<any> = new BehaviorSubject<boolean>(true);
  public isExternal$: Observable<any> = this.isExternal.asObservable();

  public roles: BehaviorSubject<any> = new BehaviorSubject<string[]>([]);
  public roles$: Observable<any> = this.roles.asObservable();

  constructor(private auth: AuthService) {
    this.auth.userProfile$.subscribe((value) => {
      if (value) {
        localStorage.setItem("userPicture", value.picture);
        this.userPicutre.next(value.picture);
        this.roles.next(value[`http://allegion.com/claims/roles`]);
        this.profile.next(value);
        this.profile.complete();
      }
    });
  }

  getProfile() {
    return this.profile$;
  }

  getUserPicture() {
    return this.userPicutre$;
  }

  getUserRoles() {
    return this.roles$;
  }

  getExternal() {
    return this.isExternal$;
  }
}
